"use client";

import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Postnatal() {
  return <section data-section-id="2821" id="accompagnement-postnatal-à-domicile-à-genève-nyon-et-la-côte" className="bg-background text-foreground relative w-full min-h-[600px] lg:min-h-[85vh] overflow-hidden flex flex-col justify-between">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/postnatal_hero_bg.webp)]" />

      {/* Gradient Overlay: Opaque ivory/cream on the left, fading to transparent on the right */}
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 lg:via-background/75 to-transparent" />

      {/* Top spacing spacer */}
      <div className="relative z-10 pt-6 sm:pt-8 px-6 sm:px-10 lg:px-16" />

      {/* Main Content - Vertically Centered, Left-Aligned Text Block */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 my-auto py-12 lg:py-16">
        <div className="max-w-xl lg:max-w-2xl flex flex-col items-start">
          {/* 1. Tagline */}
          <p className="text-xs sm:text-sm font-sans font-semibold uppercase tracking-[0.25em] text-primary mb-4">Isabel Roulet - Accompagnante postnatale Le mois d'or</p>

          {/* 2. Main Title */}
          <h1 className="font-serif font-normal text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.1] tracking-tight text-foreground text-balance mb-6 sm:mb-8">
            À côté des familles dès la naissance.
          </h1>

          {/* 3. Paragraph with link */}
          <p className="font-sans text-base sm:text-lg leading-relaxed text-foreground/90 mb-8 sm:mb-10 max-w-lg">
            <Link to="/AccommodationsPage" className="text-foreground hover:text-primary transition-colors underline underline-offset-4 decoration-primary/40 hover:decoration-primary font-medium">Accompagnement post-partum à domicile à Nyon, sur La Côte et à Genève</Link>
            .
            <span className="block mt-2 text-foreground/75 text-sm sm:text-base font-light">
              Postpartum support for mothers and families in French &amp; English, in Geneva, Nyon &amp; La Côte region.
            </span>
          </p>

          {/* 4. Action Button */}
          <div className="mt-auto">
            <Button asChild className="w-full sm:w-auto h-14 px-10 rounded-lg bg-primary text-primary-foreground font-sans font-medium text-base tracking-wider uppercase shadow-sm hover:bg-foreground hover:text-background transition-all duration-300">
              <Link to="/AccommodationsPage">
                ME SERVICES
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom Indicator */}
      <div className="relative z-10 pb-6 sm:pb-8 px-6 sm:px-10 lg:px-16 flex items-center gap-4">
        <div className="flex items-center gap-2 font-sans text-xs tracking-[0.2em] uppercase text-foreground/70">
          <ArrowDown className="size-3.5 text-primary" />
        </div>
      </div>
    </section>;
}